module.exports = __webpack_public_path__ + "img/20240424075905448agi.d8a2d75d.jpg";